import React from 'react';
import Translate from '../../../components/shared/localization/localize';
import { TransferStatus, TransferStatusNames } from '../../../modules/dialogs/transfer/consts';
import { Activity } from '../../../modules/dialogs/transfer/model';
import { isClosedTx } from '../../../modules/dialogs/transfer/utils';

interface Props {
  a: Activity;
  isSender: boolean;
}

const LogStatus: React.FC<Props> = ({ a }) => {
  let output = <></>;
  if (isClosedTx(a.status)) {
    const statusTag = TransferStatusNames[a.status];
    switch (a.status) {
      case TransferStatus.COMPLETED:
        output = (
          <span style={{ color: 'green' }}>
            <Translate message={statusTag}></Translate>
          </span>
        );
        break;
      case TransferStatus.REJECTED:
      case TransferStatus.DISCARTED:
      case TransferStatus.CANCELLED:
        output = (
          <span style={{ color: 'red' }}>
            <Translate message={statusTag}></Translate>
          </span>
        );
        break;
    }
  }
  return output;
};

export default LogStatus;
